var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competition-col-pd"},_vm._l((_vm.errors),function(error,index){return _c('b-row',{key:(error + "-" + index)},[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(error))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }